import axios from "axios";

const api = axios.create({baseURL: "/api"});

// Public
export const getProducts = (params = {}) => api.get("/products", {params});
export const getProduct = (id) => api.get(`/products/${id}`);
export const getCategories = () => api.get("/categories");
export const placeOrder = (data) => api.post("/orders", data);
export const getOrder = (orderNumber) => api.get(`/orders/${orderNumber}`);
export const trackOrder = (orderNumber) =>
  api.get("/orders/track", {params: {orderNumber}});
export const getReviews = (params = {}) => api.get("/reviews", {params});
export const getFeaturedReviews = (limit = 6) =>
  api.get("/reviews/featured", {params: {limit}});
export const submitReview = (data) => api.post("/reviews", data);

// Admin — Products
export const adminGetProducts = (params = {}) =>
  api.get("/products", {params: {...params, isActive: undefined, limit: 100}});
export const adminCreateProduct = (formData) =>
  api.post("/products", formData, {
    headers: {"Content-Type": "multipart/form-data"},
  });
export const adminUpdateProduct = (id, data) =>
  api.put(`/products/${id}`, data);
export const adminDeleteProduct = (id) => api.delete(`/products/${id}`);

// Admin — Images
export const adminAddImages = (productId, formData) =>
  api.post(`/products/${productId}/images`, formData, {
    headers: {"Content-Type": "multipart/form-data"},
  });
export const adminUpdateImage = (productId, imageId, data) =>
  api.patch(`/products/${productId}/images/${imageId}`, data);
export const adminDeleteImage = (productId, imageId) =>
  api.delete(`/products/${productId}/images/${imageId}`);

// Admin — Videos
export const adminAddVideo = (productId, formData, onUploadProgress) =>
  api.post(`/products/${productId}/videos`, formData, {
    headers: {"Content-Type": "multipart/form-data"},
    onUploadProgress,
  });
export const adminDeleteVideo = (productId, videoId) =>
  api.delete(`/products/${productId}/videos/${videoId}`);

// Admin — Categories
export const adminCreateCategory = (data) => api.post("/categories", data);
export const adminUpdateCategory = (id, data) =>
  api.put(`/categories/${id}`, data);
export const adminDeleteCategory = (id) => api.delete(`/categories/${id}`);

// Admin — Orders
export const adminGetOrders = () => api.get("/orders");
export const adminUpdateOrderStatus = (id, data) =>
  api.patch(`/orders/${id}/status`, data);

// Admin — Reviews
export const adminGetReviews = (status) =>
  api.get("/reviews/admin", {params: {status: status || undefined}});
export const adminUpdateReviewStatus = (id, status) =>
  api.patch(`/reviews/${id}/status`, {status});
export const adminDeleteReview = (id) => api.delete(`/reviews/${id}`);

export default api;
